import React from 'react';
import { Modal } from 'antd';
import QRCode from 'react-qr-code';

const LegacySurveyQrCodeModal = ({ open, handleClose, survey }) => {
  const downloadQRCode = () => {
    const svg = document.getElementById('qrCodeEl');
    if (!svg) return;

    const serializer = new XMLSerializer();
    const svgStr = serializer.serializeToString(svg);

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const img = new Image();

    const svgBlob = new Blob([svgStr], {
      type: 'image/svg+xml;charset=utf-8',
    });
    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      URL.revokeObjectURL(url);

      const pngUrl = canvas.toDataURL('image/png');

      const aEl = document.createElement('a');
      aEl.href = pngUrl;
      aEl.download = 'qr_code.png';
      document.body.appendChild(aEl);
      aEl.click();
      document.body.removeChild(aEl);
    };

    img.src = url;
  };

  return (
    <Modal
      title={'Qr code'}
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ปิด"
      onOk={downloadQRCode}
      width={'30vw'}
    >
      <div>
        <QRCode
          size={256}
          id="qrCodeEl"
          style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
          title={survey.title}
          value={`${process.env.REACT_APP_SURVEY_URL}/` + survey.id}
          viewBox={`0 0 128 128`}
        />
      </div>
    </Modal>
  );
};

export default LegacySurveyQrCodeModal;
